<template>
  <v-container fluid>
    <v-toolbar :color="background" flat height="170" class="my-2">
      <div>
        <h1>{{ development.name }}</h1>
        <span>{{ unitType }}</span>
        <span> | </span>
        <span>{{ contractType }}</span>
      </div>
      <v-spacer></v-spacer>
      <img :src="image.src" class="mx-4" :alt="image.alt_text" height="150px" />
    </v-toolbar>

    <v-card flat class="card--outlined">
      <v-card-title>
        <span class="headline">Cotizador</span>
      </v-card-title>
      <v-card-subtitle>
        <span class="grey--text">
          Configuración del cotizador para el desarrollo
        </span>
      </v-card-subtitle>
      <v-card-text>
        <div>
          <SimpleSwitch
            :value="development.miscellaneous.quote.active"
            @input="saveQuote({ active: $event })"
            label="Cotizador v1"
            hint="Habilita o deshabilita el cotizador en su versión 1"
            colorIcon="primary"
            true-value="on"
            false-value="off"
            disabled
          />
        </div>
        <SimpleSwitch
          :value="development.miscellaneous.quote.active_two"
          @input="saveQuote({ active_two: $event })"
          label="Cotizador v2"
          hint="Habilita o deshabilita el cotizador en su versión 2"
          colorIcon="primary"
          true-value="on"
          false-value="off"
        />
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
    <Inventory
      :inventory="inventory"
      :amenities="amenities"
      @update:inventory="handleInventoryUpdate"
    />
  </v-container>
</template>
<script>
import { CONTRACT_TYPE } from "../../property/const";
import {
  fetchDevelopmentInventory,
  editDevelopment
} from "../../../api/mntto/developments";

const MAP_UNIT_TYPE = {
  department: "Departamento",
  lots: "Lote",
  offices: "Oficina"
};

const MAP_CONTRACT_TYPE = {
  [CONTRACT_TYPE.sale]: "Venta",
  [CONTRACT_TYPE.rent]: "Renta",
  [CONTRACT_TYPE.both]: "Venta y Renta"
};

export default {
  name: "DevelopmentDetail",
  components: {
    SimpleSwitch: () => import("../../common/SimpleSwitch.vue"),
    Inventory: () => import("./Inventory.vue")
  },
  props: {
    development: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      background: "blue-grey lighten-4",
      loading: false,
      inventory: [],
      amenities: [],
      developmentId: this.$route.params.id
    };
  },
  async created() {
    this.loading = true;
    const { data } = await fetchDevelopmentInventory(this.development._id);
    this.inventory = data.properties;
    this.amenities = data.amenities;
    this.loading = false;
  },
  computed: {
    image() {
      if (this.development.media?.featured_image?.src) {
        return {
          src: this.development.media.featured_image.src,
          alt_text: this.development.media.featured_image.alt_text
        };
      }
      return {
        src: `${process.env.BASE_URL}img/undraw_house_searching_n8mp.svg`,
        alt_text: "Capital28"
      };
    },
    unitType() {
      return MAP_UNIT_TYPE[this.development.unit_types] || "Departamento";
    },
    contractType() {
      return MAP_CONTRACT_TYPE[this.development.contract_type] || "Venta";
    }
  },
  methods: {
    async saveQuote(newQuote) {
      this.loading = true;
      const quote = {
        ...this.development.miscellaneous.quote,
        ...newQuote
      };
      const { data } = await editDevelopment(this.development._id, {
        miscellaneous: {
          ...this.development.miscellaneous,
          quote
        }
      });
      if (!data)
        return this.$snotify.error("No se pudo actualizar", "Error :(");
      this.$emit("update:development", data);
      this.loading = false;
    },
    handleInventoryUpdate(data) {
      this.inventory = data.properties;
      this.amenities = data.amenities;
    }
  }
};
</script>

<style scoped>
.card--outlined {
  border: 1px solid #e0e0e0;
  margin: 0.5rem;
}
</style>
